const getRecurrence = (plan_id: string, isAddon: boolean): string => {
  return plan_id === '165'
    ? '/yr'
    : plan_id !== '112' && isAddon
    ? '/pkg'
    : '/mo'
}

export default getRecurrence
